import IhmException from '@ch-types/CoralExceptionTypes/IhmException';

export default class InsufficientQuantityException extends IhmException {}
